exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-text-field.v-text-field--solo .v-input__control{min-height:15px;margin-right:20px}.search{width:100%}.iconpadding .v-list__tile__avatar{min-width:40px}.v-overlay--active{transform:translateX(300px)!important}.dont-touch{touch-action:none!important;pointer-events:none!important}#app-sidebar .v-toolbar__content{height:56px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77ccc5fd","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/SideNav.vue
// module id = 454
// module chunks = 0